import React, {useEffect, useState} from 'react'
import axios from 'axios'
import {
	Link
} from 'react-router-dom';
import Loader from '../../components/Loader';
import axiosInstance from '../../utils/api';

type Props = {}

interface PumpInterface {
    id: number;
    serial: string;
    brand?: string;
    node?: string;
    model?: string;
}

const PumpList = (props: Props) => {
    const title = "Pump"
    const [loading, setLoading] = useState(false)
    const [pumps, setPumps] = useState<Array<PumpInterface>>([])

    useEffect(() => {
        getDateList()
    }, [])

    function getDateList() {
        setLoading(true)
        axiosInstance.get("https://api.cl-ds.com/internal/operations/v1/pump").then(res=>{
            setLoading(false)
            console.log(res.data)
            setPumps(res.data)
        }).catch(err=>{
            setLoading(false)
            console.log(123, err)
        })
    }

    function handleDelete(id:string) {
        if (!window.confirm("Are you sure you want to delete record?")) return

        setLoading(true)
        axiosInstance.delete(`https://api.cl-ds.com/internal/operations/v1/pump/${id}/`).then(res=>{
            setLoading(false)
            console.log(11, res)
            alert(res.data.message)
            getDateList()
        }).catch(err=>{
            setLoading(false)
            console.log(123, err)
        })
    }
    

    return (
            <div className="col-12">
            {loading && ( <Loader/> )}

                <div className="card">
                    <div className="card-body">
                        <div className="row px-2" style={{display:"grid", gridTemplateColumns:"1fr 1fr"}}>
                            <h5 className="card-title">{title} List</h5>
                            <div style={{display:"flex", justifyContent:"end", alignSelf:"center"}}>
                                
                                <Link to="/pump/add" >
                                    <button type="button" className="btn btn-outline-info">Create</button>
                                </Link>
                            </div>

                        </div>


                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <th scope="col">Serial</th>
                                    {/* <th scope="col">Node</th> */}
                                    <th scope="col">Brand</th>
                                    <th scope="col">Model</th>
                                    <th scope="col">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {pumps.map( (pump, index) => {

                                    return (
                                        <tr key={index}>
                                            <th scope="row">{pump.serial}</th>
                                            {/* <td>{pump.node}</td> */}
                                            <td>{pump.brand}</td>
                                            <td>{pump.model}</td>
                                            <td>
                                                <Link to={`/pump/edit/${pump.id}`} >
                                                    <button type="button" className="btn btn-outline-info"><i className="bi bi-pencil"></i></button>
                                                </Link>
                                                <button type="button" className="btn btn-outline-danger mx-1" onClick={()=>{handleDelete(pump.id.toString())}}><i className="bi bi-trash"></i></button>
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    

                    </div>
                </div>

            </div>

    )
}

export default PumpList